import { IconButton, Tooltip } from '@mui/material';
import { useState } from 'react'
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import { colors } from 'styles/colors';
import { snackbarService } from 'services/snackbarService';
import CustomDialog from 'components/dialogs/CustomDialog';
import { useAcceptInvitation } from 'hooks/useUsers';
import { useAuth } from 'context/AuthContext';
import CheckIcon from 'icons/CheckIcon';

interface Props {
  doctorId: number;
  refetch?: () => void;
}

function AcceptDashboardInvitationActionButton({ doctorId, refetch }: Props) {
  const { user } = useAuth();
  const [open, setOpen] = useState<boolean>(false);

  const { mutate: acceptMutation, isLoading } = useAcceptInvitation(
    (data: any) => {
      setOpen(false);
      snackbarService.showSnackbar('Invitation has been accepted successfully', 'success');
      refetch?.();
    },
    (err: any) => {
      snackbarService.showSnackbar(err, 'error');
    },
  )

  const handleAccept = () => {
    acceptMutation({
      userId: user.id,
      doctorId,
    });
  }

  return (
    <>
      <Tooltip title={'Accept'}>
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            width: 25,
            height: 25,
            backgroundColor: colors.success,
            borderRadius: '4px',
            padding: 0,
            '&:hover': {
              backgroundColor: colors.success,
            },
          }}
        >
          <CheckIcon size={15} color={'white'} />
        </IconButton>
      </Tooltip>
      <CustomDialog
        open={open}
        title='Accept request'
        message={`Are you sure you want to accept this request?`}
        buttons={[
          <CustomButton
            key='cancel'
            text="Cancel"
            variant='outlined'
            color='success'
            onClick={() => setOpen(false)}
            disabled={isLoading}
          />,
          <CustomButton
            key='accept'
            text="Accept"
            color='success'
            intent='success'
            onClick={handleAccept}
            loading={isLoading}
          />
        ]}
      />
    </>
  )
}

export default AcceptDashboardInvitationActionButton;